<template>
  <label
    v-if="label"
    :for="target"
    class="absolute -top-2 left-2 z-5 -mt-px inline-block rounded-md bg-white/75 px-1 text-xs font-medium text-gray-900 capitalize-first dark:bg-slate-800/80 dark:text-white"
    :class="{
      'cursor-context-menu': disabled,
      [labelClass]: !!labelClass
    }"
  >
    <span class="truncate first-letter:uppercase">{{ label }}&nbsp;</span>
    <span v-if="label && required" class="text-red-600">*</span>
  </label>
</template>

<script>
export default {
  name: 'BaseLabelTop',
  props: {
    target: {
      type: String,
      required: false,
      default: ''
    },
    label: {
      type: String,
      required: false,
      default: ''
    },
    labelClass: {
      type: String,
      required: false,
      default: ''
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    required: {
      type: Boolean,
      required: false,
      default: false
    }
  }
}
</script>
